



























































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Textbox from "@/components/atoms/Textbox.vue";
import SelectBox, { ISelectBox } from "@/components/atoms/SelectBox.vue";
import Calendar from "@/components/atoms/Calendar.vue";
import { CompaniesStore, DepartmentsStore } from "@/store";
import { ICompanyState } from "@/store/modules/companies";
import _ from "lodash";
import moment from "moment-timezone";
import { ICompanyDepartment, IDepartment } from "@/store/modules/departments";

@Component({
  components: { Textbox, SelectBox, Calendar },
})
export default class EmployeeSearchItem extends Vue {
  name: "EmployeeSearchItem";

  private empCd = "";
  private lastName = "";
  private firstName = "";
  private lastNameKana = "";
  private firstNameKana = "";
  private companyId: string | null = null;
  private departmentId: string | null = null;
  private targetDate: Date = moment().tz("Asia/Tokyo").toDate();
  private isOpenSearchItem = true;

  @Prop({ default: false })
  private hasError: boolean;

  @Watch("hasError")
  onChanged(hasError: boolean) {
    this.isOpenSearchItem = hasError;
  }

  get companyList(): ISelectBox[] {
    let companies: ICompanyState[] = CompaniesStore.getCompanies;
    let sortCompanies = _.sortBy(companies, (company: ICompanyState) => {
      return company.disp_sort;
    });
    let list: ISelectBox[] = [];
    let company: ICompanyState;
    for (company of sortCompanies) {
      if (company.company_name && company.company_id) {
        list.push({
          key: String(company.company_id),
          innerValue: String(company.company_id),
          diaplayValue: company.company_name,
        });
      }
    }
    return list;
  }

  get departmentList(): ISelectBox[] {
    const companyId = Number(this.companyId);
    if (!companyId) return [];

    // 所属リストは、選択されている会社に紐づく所属に絞り込んで表示する.
    let companyDepartments: ICompanyDepartment[] = _.filter(
      DepartmentsStore.getDepartments.sync_target_departments,
      (departments: ICompanyDepartment) => {
        return departments.tt_company_id === companyId;
      }
    );
    if (companyDepartments.length <= 0) return [];

    let sortedDepartments: IDepartment[] = _.sortBy(
      companyDepartments[0].departments, // 同じ会社IDの所属一覧は複数存在しない為、先頭の所属一覧のみ表示する.
      (department: IDepartment) => {
        return department.tt_disp_sort;
      }
    );

    let list: ISelectBox[] = [];
    let department: IDepartment;
    for (department of sortedDepartments) {
      if (department.tt_department_name && department.tt_department_id) {
        list.push({
          key: String(department.tt_department_id),
          innerValue: String(department.tt_department_id),
          diaplayValue: department.tt_department_name,
        });
      }
    }
    return list;
  }

  private onClickSearchButton(): void {
    this.$emit("on-click-search-button", {
      emp_cd: this.empCd === "" ? null : this.empCd,
      last_name: this.lastName === "" ? null : this.lastName,
      first_name: this.firstName === "" ? null : this.firstName,
      last_name_kana: this.lastNameKana === "" ? null : this.lastNameKana,
      first_name_kana: this.firstNameKana === "" ? null : this.firstNameKana,
      company_id: this.companyId === null ? null : Number(this.companyId),
      department_id:
        this.departmentId === null ? null : Number(this.departmentId),
      target_date: this.targetDate,
    });

    // 検索ボタン押下時は、検索結果一覧の表示領域を確保する為、検索フィールドを閉じる.
    this.isOpenSearchItem = false;
  }

  private onClickSearchItemTitle(): void {
    this.isOpenSearchItem = !this.isOpenSearchItem;
  }
}
